<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from '@/components/Navbar.vue';
import ToastNotification from '@/components/ToastNotification.vue';
import AppFooter from '@/examples/Footer.vue';
const route = useRoute();
const workspace = computed(() => Boolean(route.meta.requiresAuth));
</script>
<template>
  <div :class="workspace ? 'workspace' : 'public-layout'">
    <a class="skip-link" href="#main-content">{{ $t('workspace.skip') }}</a>
    <Navbar :workspace="workspace" />
    <main id="main-content" class="workspace-main" tabindex="-1"><router-view /></main>
    <AppFooter v-if="!workspace" />
    <ToastNotification />
  </div>
</template>
